import { useState } from 'react'
import waveIcon from '@assets/icons/wave.png'
import orangeIcon from '@assets/icons/Orange.png'
import mtnIcon from '@assets/icons/mtn.png'

function PaymentMethodSelector({ selectedMethod, onMethodChange, phoneNumber, onPhoneNumberChange, countryCode, onCountryCodeChange }) {
  const [showComingSoonModal, setShowComingSoonModal] = useState(false)
  const [comingSoonName, setComingSoonName] = useState('')

  const paymentMethods = [
    { id: 'wave',   name: 'Wave',             icon: waveIcon,   color: 'from-blue-500 to-blue-600',     bg: 'bg-gradient-to-br from-blue-500 to-blue-600',     text: 'text-white', available: true },
    { id: 'orange', name: 'Orange Money',     icon: orangeIcon, color: 'from-orange-500 to-orange-600', bg: 'bg-gradient-to-br from-orange-500 to-orange-600', text: 'text-white', available: false },
    { id: 'mtn',    name: 'MTN Mobile Money', icon: mtnIcon,    color: 'from-yellow-400 to-yellow-500', bg: 'bg-gradient-to-br from-yellow-400 to-yellow-500', text: 'text-gray-900', available: false },
  ]

  const countries = [
    { code: '+225', name: 'CI', flag: '🇨🇮' },
    { code: '+221', name: 'SN', flag: '🇸🇳' },
    { code: '+223', name: 'ML', flag: '🇲🇱' },
    { code: '+226', name: 'BF', flag: '🇧🇫' },
  ]

  const handleMethodClick = (method) => {
    if (!method.available) {
      setComingSoonName(method.name)
      setShowComingSoonModal(true)
      return
    }
    onMethodChange(method.id)
  }

  return (
    <div className="space-y-6">
      {/* Méthodes de paiement */}
      <div>
        <label className="block text-sm font-semibold text-[#001F3F] mb-4">
          Méthode de paiement<span className="text-red-600">*</span>
        </label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {paymentMethods.map((method) => (
            <button
              key={method.id}
              type="button"
              onClick={() => handleMethodClick(method)}
              className={`relative p-6 rounded-xl border-2 transition-all duration-300 ${
                !method.available
                  ? `${method.bg} opacity-60 cursor-not-allowed border-transparent`
                  : selectedMethod === method.id
                    ? `${method.bg} border-white/30 shadow-xl transform scale-105`
                    : `${method.bg} border-transparent hover:shadow-lg hover:scale-105`
              }`}
            >
              {/* Badge "Bientôt disponible" */}
              {!method.available && (
                <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 px-3 py-0.5 bg-gray-400 text-white text-[10px] font-bold rounded-full whitespace-nowrap">
                  Bientôt disponible
                </div>
              )}

              {selectedMethod === method.id && method.available && (
                <div className="absolute top-3 right-3">
                  <svg className="w-6 h-6 text-[#D4AF37]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
              )}

              <div className="flex flex-col items-center gap-3">
                <div className="w-16 h-16 rounded-full bg-white/20 p-3 flex items-center justify-center shadow-lg">
                  <img src={method.icon} alt={method.name} className="w-full h-full object-contain" />
                </div>
                <span className={`text-sm font-semibold text-center ${method.text}`}>
                  {method.name}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Numéro de téléphone (uniquement pour Wave) */}
      {selectedMethod === 'wave' && (
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border border-blue-200">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
              <img src={waveIcon} alt="Wave" className="w-6 h-6 object-contain" />
            </div>
            <div>
              <p className="text-sm font-bold text-[#001F3F]">Paiement via Wave</p>
              <p className="text-xs text-gray-500">Vous serez redirigé vers la page Wave pour finaliser le paiement</p>
            </div>
          </div>
          <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-lg border border-blue-200">
            <svg className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-xs text-blue-700 font-medium">
              Après confirmation du paiement Wave, votre publication sera automatiquement activée.
            </p>
          </div>
        </div>
      )}

      {/* Modal "Bientôt disponible" */}
      {showComingSoonModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={() => setShowComingSoonModal(false)}>
          <div className="bg-white rounded-2xl p-8 max-w-sm w-full shadow-2xl text-center" onClick={e => e.stopPropagation()}>
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[#001F3F] mb-2">{comingSoonName}</h3>
            <p className="text-gray-600 mb-2 font-medium">Bientôt disponible !</p>
            <p className="text-sm text-gray-500 mb-6">
              L'intégration <strong>{comingSoonName}</strong> est en cours de développement.<br />
              Pour le moment, veuillez utiliser <strong>Wave</strong> pour vos paiements.
            </p>
            <button
              onClick={() => setShowComingSoonModal(false)}
              className="w-full py-3 bg-gradient-to-r from-[#D4AF37] to-[#C49B2E] text-white font-bold rounded-xl hover:shadow-lg transition-all"
            >
              OK, j'utilise Wave
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default PaymentMethodSelector
